/**
 * @prettier
 */

import { browserHistory } from 'react-router';
import { CardCatalogActionTypes } from '~/cards/actions/cardCatalogActionTypes';
import { fetchAvailableSamplesCount } from '~/cards/components/common/Samples/util/api/fetchAvailableSamplesCount';

// Calling setMultiSampleEnabled without the `enabled` argument will set multi sample mode to
// the `multi_sample_mode` query param state in the URL.
// using `ignoreQuery` will leave out the query string
// this is used for the digital customization flow free samples step, where the query is unnecessary
export const setMultiSampleEnabled = (cardType, enabled = null, ignoreQuery = false) => {
  return (dispatch) => {
    const { query, pathname } = browserHistory.getCurrentLocation();

    let isMultiSampleMode = false;

    const isOrderAndDrafts =
      pathname.includes('projects/drafts') ||
      pathname.includes('projects/finished') ||
      pathname.includes('projects/digital');

    if (!ignoreQuery && query && query.multi_sample_mode === 'multisampleenabled') {
      isMultiSampleMode = true;
    }

    if (enabled !== null) {
      isMultiSampleMode = enabled;
    }
    if (!ignoreQuery) {
      const newQuery = { ...query };

      if (isMultiSampleMode) {
        newQuery.multi_sample_mode = 'multisampleenabled';
      } else {
        delete newQuery.multi_sample_mode;
      }

      const queryString = Object.keys(newQuery)
        .map((k) => `${k}=${newQuery[k]}`)
        .join('&');

      const search = `?${queryString}`;

      if (isOrderAndDrafts) {
        window.location.href = `/wedding-planning/save-the-date/shop${search}`;
      } else {
        browserHistory.push({
          pathname,
          search,
        });
      }
    }

    let samplesCountPromise;

    if (cardType) {
      samplesCountPromise = fetchAvailableSamplesCount(cardType);
    } else {
      samplesCountPromise = Promise.resolve({ order_placed: 0, maximum_orders_allowed: 5 });
    }

    return samplesCountPromise.then((result) => {
      const count = {
        ordersPlaced: result.order_placed,
        maximumOrdersAllowed: result.maximum_orders_allowed,
      };

      dispatch({
        type: CardCatalogActionTypes.SET_MULTISAMPLE_ENABLED,
        payload: { enabled: isMultiSampleMode, count },
      });
      // * re-fetch content w/wo sample available content if applicable
      if (enabled !== null) {
        dispatch({
          type: CardCatalogActionTypes.UPDATE_SEARCH_FILTERS,
          payload: { key: 'single_sample_available', value: isMultiSampleMode },
        });
      }

      return Promise.resolve();
    });
  };
};

export const disableMultiSampleMode = () => setMultiSampleEnabled(null, false);

export const setMultiSampleSelected = (card, selected, initialColor = null) => {
  return {
    type: CardCatalogActionTypes.SET_MULTISAMPLE_SELECTED,
    payload: { card, selected, initialColor },
  };
};

export const clearMultiSampleSelected = () => {
  return {
    type: CardCatalogActionTypes.CLEAR_MULTISAMPLE_SELECTED,
  };
};
